module.exports = __webpack_public_path__ + "static/img/alert_welcome_bg.464d5a2e.png";